/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
'use strict';
export function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/monaco-editor/esm/vs/base/common/numbers.js
// module id = 545
// module chunks = 53